import { render, staticRenderFns } from "./CourseContentSectionChild.vue?vue&type=template&id=c4837576&scoped=true&"
import script from "./CourseContentSectionChild.vue?vue&type=script&lang=js&"
export * from "./CourseContentSectionChild.vue?vue&type=script&lang=js&"
import style0 from "./CourseContentSectionChild.vue?vue&type=style&index=0&id=c4837576&prod&lang=css&"
import style1 from "./CourseContentSectionChild.vue?vue&type=style&index=1&id=c4837576&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4837576",
  null
  
)

export default component.exports